// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * ALMA Chatbot API
 * API to manage Alma chatbot interactions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MainFeedbackResponse
 */
export interface MainFeedbackResponse {
  /**
   *
   * @type {string}
   * @memberof MainFeedbackResponse
   */
  message?: string;
}

/**
 * Check if a given object implements the MainFeedbackResponse interface.
 */
export function instanceOfMainFeedbackResponse(
  value: object,
): value is MainFeedbackResponse {
  return true;
}

export function MainFeedbackResponseFromJSON(json: any): MainFeedbackResponse {
  return MainFeedbackResponseFromJSONTyped(json, false);
}

export function MainFeedbackResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MainFeedbackResponse {
  if (json == null) {
    return json;
  }
  return {
    message: json['message'] == null ? undefined : json['message'],
  };
}

export function MainFeedbackResponseToJSON(json: any): MainFeedbackResponse {
  return MainFeedbackResponseToJSONTyped(json, false);
}

export function MainFeedbackResponseToJSONTyped(
  value?: MainFeedbackResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    message: value['message'],
  };
}
